//import Vue from 'vue'
//import VueResource from 'vue-resource'
import {
  ERROR_OK,
  ERROR_PARAMERR,
  ERROR_NOTEXIST,
  ERROR_PASSWORD,
  ERROR_USERNOTEXIST,
  ERROR_TOKENEXPIRE,
  ERROR_NOTSUPPORTMAILBOX,
  ERROR_SENDMAILFAIL,
  ERROR_PERMISSIONDIE,
  ERROR_VERIFYCODE,
  ERROR_FILEEXTERR,
  ERROR_CREATEFILEFAIL,
  ERROR_FETCHINGDEVICEINFO,
  ERROR_FETCHDEVICEINFOFAIL,
  ERROR_UNKNOWN
} from './errorType'

import { USER_LOGIN, USER_LOGOUT } from '../store/modules/user'

export default {
  errMsgNotify: (Error_code, handle) => {
    console.log('Err:' + Error_code)
    var title = 'CODE:' + Error_code
    var message = '错误！'
    var type = 'error'

    switch (Error_code) {
      case ERROR_OK:
        {
          title = '成功'
          message = '处理成功！'
          type = 'success'
        }
        break
      case ERROR_PARAMERR:
        message = '参数错误！'
        break
      case ERROR_NOTEXIST:
        {
          handle.$message({
            showClose: true,
            message: '服务器数据不存在！',
            type: 'warning'
          })
          return
        }
        break
      case ERROR_PASSWORD:
      case ERROR_USERNOTEXIST:
        {
          handle.$message({
            showClose: true,
            message: '用户名或密码错误！',
            type: 'error'
          })
          return
        }
        break
      case ERROR_TOKENEXPIRE:
        message = '登陆过期,请重新登陆！'
        handle.$store.dispatch('USER_LOGOUT')
        // handle.$router.replace('/login');
        if (handle.$router.currentRoute.path !== '/login') {
          handle.$router.push({path: '/login', query: {redirect: handle.$router.currentRoute.fullPath}})
        }

        break
      case ERROR_NOTSUPPORTMAILBOX:
        message = '不支持的邮箱类型！'
        break
      case ERROR_SENDMAILFAIL:
        message = '邮件发送失败！'
        break
      case ERROR_PERMISSIONDIE:
        message = '权限不足！'
        break
      case ERROR_VERIFYCODE:
        message = '验证码错误！'
        break
      case ERROR_FILEEXTERR:
        message = '文件类型错误！'
        break
      case ERROR_CREATEFILEFAIL:
        message = '创建文件失败！'
        break
      case ERROR_FETCHINGDEVICEINFO:
        message = '获取device info中！'
        type = 'info'
        break
      case ERROR_FETCHDEVICEINFOFAIL:
        message = '获取device info fail！'
        type = 'info'
        break
      default:
        message = '服务器出现未知错误！'
        type = 'warning'
        break
    };

    handle.$message({
      showClose: true,
      message: message,
      type: type
    })

    // handle.$notify({
    //   title: title,
    //   message: message,
    //   type: type
    // });
  },
  catchMsgNotify: (handle) => {
    handle.$message({
      showClose: true,
      message: '请求服务器数据异常，请联系管理员！',
      type: 'error'
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/api/notifyMsg.js
// module id = null
// module chunks = 